<template>
	<div class="row mb-2">
		<div class="col-2"></div>
		<div class="col-8">
			<div role="group">
				<label for="passwordref" class="fw-500">{{$t('login_password')}}</label>
				<b-form-input :type="typePass" id="passwordref" v-model="password" :placeholder="$t('login_password_ph')" class="fw-500" trim></b-form-input>
			</div>
			<div class="icon-lock-login">&nbsp;</div>
			<div class="eyeOpen pointer" @click="showPass()">
				<i v-if="typePass=='password'" class="icon-view-black"></i>
				<i v-else class="icon-stop-view-black"></i>
			</div>
		</div>
		<div class="col-2"></div>
	</div>
</template>

<script>
import loginControl from '@/mixins/Login/loginControl';

export default {
	name: 'InputPassword',

	mixins: [
		loginControl
	],

	data (){
		return {
			password: null,
			typePass: 'password',
		}
	},

	watch: {
		password(){
			this.$emit('update:updatePassword', {
				password: this.password
			});
		},
	},
}
</script>

<style lang="scss" scoped>
	// Não mostrar o olho do Edge no input
	::-ms-reveal {
		display: none;
	}
</style>
